module.exports = __webpack_public_path__ + "img/26.257af602.png";